import { Quill } from 'vue-quill-editor';
/* eslint-disable no-control-regex */

export const isString = function (value: any): boolean {
  return value && typeof value === 'string';
};

//get number of characters to retain based on maxLength and weightings of mentions

export const getCharactersToRetain = function (
  ops: any[], //should be a list of inserts into the editor
  maxLength: number,
  mentionWeight: number //weighting of non string inserts (ie blots, in our case, mentions). This function currently doesn't check to see if the blot is actually a mention
): { retain: number; length: number } {
  let length = 0;
  let charactersToRetain = 0;
  for (let i = 0; i < ops.length; i++) {
    //for every op get the value inserted. If its not an insertion op then leave it be. The input to the function is likely incorrect
    const val = ops[i].insert;
    if (!val) continue;
    //if the insert is simple text
    else if (isString(val)) {
      //diff is the smaller of the length of the text and the number of characters before we reach maxLength
      //ie if our current length is 315 and maxLength is 320. If insert is 10 characters long, we have to trim it to 5chars
      //There is a special case for the last op, because quill auto adds a '\n' to the end of all text. hence we must reduce the last op text length by 1 to remove it.
      //However, ignore the special case if the trailing characters are '\n\n', (because quill adds \n to end of text, it doesnt actually new line a trailing \n. To do that we must preserve the extra \n)
      const diff =
        i == ops.length - 1 &&
        !(val.length > 1 && val.substring(val.length - 2) == '\n\n')
          ? Math.min(val.length - 1, maxLength - length)
          : Math.min(val.length, maxLength - length);

      //add diff to the length total and the retain total
      length = length + diff;
      charactersToRetain = charactersToRetain + diff;
    }
    // if the insert is not text (ie mention)
    // check do we have enough characters to insert it based on mentionWeight
    else if (maxLength - length >= mentionWeight) {
      //add to length the mentionWeight but because blots only count as 1 character just add 1 to retain.
      length += mentionWeight;
      charactersToRetain += 1;
    } else {
      break;
    }
    if (length >= maxLength) break; // once we reach maxLength we are done
  }
  return { retain: charactersToRetain, length: length };
};

export const getCharacterCount = (
  quill: any,
  maxLength: number,
  mentionWeight: number
): number => {
  const delta = quill.getContents();
  const { length } = getCharactersToRetain(delta.ops, maxLength, mentionWeight);
  return length;
};
